import { 
    IonButton,
    IonIcon,
    IonText
} from '@ionic/react';
import {
    checkmarkCircle, 
} from "ionicons/icons"
import Fade from 'react-reveal/Fade';

import "./OneStopSection.css";

// import bg image

const OneStopSection = (history,userDevice) => {

    const aboutArr = [
        'Quick delivery that you can trust',
        'Reach more customers with our 24/7 islandwide service',
        'Reduce delivery costs with every additional stop',
    ]

    return(
        <div style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/background/${userDevice==='mobile'?'mobile':'web'}-about.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: userDevice ==='mobile' ? '370px' : '587px'
        }}>
            <div style={{
                maxWidth: '1200px',
                display:'flex',
                flexDirection:'column',
                justifyContent:'flex-start',
                alignItems:'flex-start',
                padding:'55px 145px 207px 37px',
                width: '100%',
                margin: '0 auto',
            }}>
                    <div style={{
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'flex-start',
                        height:'100%',
                        marginTop: '20px',
                    }}>
                        <Fade up>
                        <div style={{height:'100%'}}>
                            <IonText 
                            className="font-s font-baloo font-regular"
                            >
                            RydeSEND
                            </IonText>
                        </div>
                        </Fade>
                        <Fade up>
                        <div style={{height:'100%'}}>
                            <IonText 
                            className="font-opensans font-semibold"
                            style={{
                                fontWeight:'700',
                                lineHeight: userDevice==='mobile' ? '1.35rem' : '3.5rem',
                                color: '#545252',
                                fontSize: userDevice==='mobile' ? '1.55rem' : '3.5rem'
                            }}
                            >
                            The One-Stop<br/>Delivery Portal
                            </IonText>
                        </div>
                        </Fade>
                        <div className="prelogin-about-textbox" style={{
                            marginBlock: '20px',
                        }}>
                            {aboutArr.map((items, index) => {
                                return(
                                    <Fade up key={index}>
                                    <div 
                                    className="prelogin-about-bullet-text"
                                    style={{
                                        marginBlock: '5px',
                                    }}
                                    key={index}>
                                        <IonIcon 
                                        className="prelogin-about-content-icon" 
                                        icon={checkmarkCircle}/>
                                        <IonText 
                                        className="font-semibold font-baloo font-pink-1"
                                        style={{
                                            marginLeft: '10px',
                                            lineHeight: userDevice==='mobile' ? '1.0rem' : '1.5rem',
                                            fontSize: userDevice==='mobile' ? '0.75rem' : '1.5rem'
                                        }}
                                        >{items}</IonText>
                                    </div></Fade>
                                )}
                            )}
                        </div>
                        <IonButton 
                        style={{
                            minWidth: '300px',
                        }}
                        className="prelogin-button font-opensans font-bold" 
                        onClick={() => history.push('/login')}>Login to RydeSEND Portal</IonButton>
                    </div>
                </div>
        </div>
    )
}

export default OneStopSection;